import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdminCommerceProvider } from '../AdminCommerceContext';

const AdminCommerceLayout: React.FC = () => {
  return (
    <AdminCommerceProvider>
      <Outlet />
    </AdminCommerceProvider>
  );
};

export default AdminCommerceLayout;